var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4787_3273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3504 0C10.5034 0 0.900391 9.603 0.900391 21.45C0.900391 32.2047 8.82204 41.0834 19.1444 42.6344V27.1343H13.8364V21.4962H19.1444V17.7441C19.1444 11.5318 22.1705 8.80605 27.3334 8.80605C29.8051 8.80605 31.1135 8.9892 31.7323 9.07335V13.9953H28.2112C26.02 13.9953 25.2544 16.0727 25.2544 18.4157V21.4979H31.6778L30.8066 27.1359H25.2544V42.6822C35.7236 41.2599 43.8004 32.3087 43.8004 21.45C43.8004 9.603 34.1974 0 22.3504 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4787_3273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.9,
    height: 42.9,
    fill: "white",
    transform: "translate(0.900391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.4450d71e7815cd100472c8cfde8bf26c.svg";
export { ForwardRef as ReactComponent };